import { untilComponentDestroyed, OnDestroyMixin } from '@w11k/ngx-componentdestroyed';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ChangeEvent, VirtualScrollComponent } from 'angular2-virtual-scroll';
import { Subject } from 'rxjs';
import { distinctUntilChanged, filter, tap } from 'rxjs/operators';

import { ExchangeQueryParameters } from '../../api/exchange.query';
import { GlitterOfferListDto } from '../../api/listResultDto';
import { ExchangeService } from '../exchange.service';
import { defs } from '../../defs';
import { NGXLogger } from 'ngx-logger';
import { GlitterOfferDto } from '../../api/glitterOfferDto'

@Component({
	selector: 'narwhalia-exchange-list',
	templateUrl: './exchange-list.component.html',
	styleUrls: ['./exchange-list.component.scss']
})
export class ExchangeListComponent extends OnDestroyMixin implements OnInit {
	@ViewChild(VirtualScrollComponent) private virtualScroll: VirtualScrollComponent;
	buffer: GlitterOfferDto[] = [];
	readonly bufferSize: number = 30;
	loading: boolean;
	scrollItems: any = [];
	totalCount: number;
	endOfList$: Subject<ChangeEvent>;

	constructor(
		private route: ActivatedRoute,
		private exchangeService: ExchangeService,
		private log: NGXLogger) {
		super();
		this.endOfList$ = new Subject();
	}

	ngOnInit() {
		this.route.queryParams.subscribe((params: ExchangeQueryParameters) => {
			if (!Object.keys(params).some(key => key === 'sortBy')) {
				params = { ...params, sortBy: defs.sortOrders.defaults.exchange };
			}

			this.exchangeService.setQueryParams(params);

			this.exchangeService.getPackages({ ...params, p: 0, ps: this.bufferSize })
				.subscribe((chunk: GlitterOfferListDto) => {
					this.buffer = chunk.items;
					this.totalCount = chunk.total;
					this.virtualScroll.scrollToIndex(0, true, 0, 0);
					this.virtualScroll.refresh();
				});
		});

		this.endOfList$
			.pipe(
				distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b)),
				tap(event => this.log.debug('ChangeEvent', event)),
				filter(event => event.end === this.buffer.length - 1 && this.buffer.length < this.totalCount),
				untilComponentDestroyed(this)
			)
			.subscribe(this.fetchMore);
	}

	fetchMore = (event: ChangeEvent) => {
		this.loading = true;
		this.log.trace('=== fetchNextChunk ===');
		this.exchangeService
			.getPackages({...this.exchangeService.queryParams.getValue(),
				p: Math.ceil(this.buffer.length / this.bufferSize),
				ps: this.bufferSize
			})
			.subscribe((chunk: GlitterOfferListDto) => {
				this.buffer = this.buffer.concat(chunk.items);
				this.loading = false;
			}, () => (this.loading = false));
	};

	removeCanceledOffer(id: string) {
		this.scrollItems = this.scrollItems.filter(offer => offer.id !== id);
	}
}